import { render, staticRenderFns } from "./VisitorsVehiclesPage.vue?vue&type=template&id=667a088b"
import script from "./VisitorsVehiclesPage.vue?vue&type=script&lang=js"
export * from "./VisitorsVehiclesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports